import conf from '../config'
import axios from 'axios'
import {getDoctorToken} from '../utils'

export const deletePatientListApi = async (params) => {

    const response = await axios({
        method: 'delete',
        url: `${conf.api.base_url}patient/${params.id}`,
        data: params,
        headers: {
            "Content-type": "application/json; charset=UTF-8",
            "Authorization": `Bearer ${getDoctorToken()}`
        }
    })

    return response
}

export default deletePatientListApi